<svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none"
    class="chevron chevron--{{direction}}"
>
    <path d="M4.5 2.41421L1.70711 5.20711C1.31658 5.59763 0.683419 5.59763 0.292895 5.20711C-0.0976289 4.81658 -0.0976289 4.18342 0.292895 3.79289L3.79289 0.292893C4.18342 -0.097631 4.81658 -0.097631 5.20711 0.292893L8.70711 3.79289C9.09763 4.18342 9.09763 4.81658 8.70711 5.20711C8.31658 5.59763 7.68342 5.59763 7.29289 5.20711L4.5 2.41421Z" fill="#4A4A4A"/>
</svg>
